(() => {
  const dialog = document.getElementById('VoicskyCookiePreferences');
  if (!dialog) return;
  const cookieSettingsEnabled = document.documentElement.dataset.voicskyCookieSettings !== 'disabled';
  const form = dialog.querySelector('form');
  const fields = form.querySelector('fieldset');
  const status = form.querySelector('[data-cookie-status]');
  const buttons = [...form.querySelectorAll('button')];
  const categories = ['preferences', 'analytics', 'marketing'];
  let apiPromise;
  let opener;
  let saving = false;
  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject(new Error('timeout')), 8000);
      if (!window.Shopify?.loadFeatures) {
        clearTimeout(timeout);
        reject(new Error('unavailable'));
        return;
      }
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
        clearTimeout(timeout);
        if (error || !window.Shopify.customerPrivacy) reject(error || new Error('unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }).catch(error => { apiPromise = undefined; throw error; });
    return apiPromise;
  };
  const setBusy = busy => {
    fields.disabled = busy;
    buttons.forEach(button => { button.disabled = busy; });
    dialog.setAttribute('aria-busy', String(busy));
  };
  const open = async trigger => {
    if (!cookieSettingsEnabled || dialog.open) return;
    opener = trigger;
    setBusy(true);
    status.textContent = dialog.dataset.loading;
    dialog.showModal();
    try {
      const api = await loadPrivacy();
      const consent = api.currentVisitorConsent();
      categories.forEach(category => { form.elements.namedItem(category).checked = consent[category] === 'yes'; });
      const sale = api.saleOfDataRegion();
      form.querySelector('[data-cookie-sale]').hidden = !sale;
      form.elements.namedItem('sale_opt_out').checked = consent.sale_of_data === 'no';
      status.textContent = '';
    } catch {
      status.textContent = dialog.dataset.loadError;
    } finally {
      setBusy(false);
    }
  };
  const save = async choice => {
    if (saving) return;
    saving = true;
    setBusy(true);
    status.textContent = dialog.dataset.saving;
    try {
      const api = await loadPrivacy();
      const consent = Object.fromEntries(categories.map(category => [category, choice === 'accept' || (choice !== 'reject' && form.elements.namedItem(category).checked)]));
      if (!form.querySelector('[data-cookie-sale]').hidden && choice === 'custom') consent.sale_of_data = !form.elements.namedItem('sale_opt_out').checked;
      await new Promise((resolve,reject) => {
        const timeout = setTimeout(() => reject(new Error('timeout')), 8000);
        api.setTrackingConsent(consent, result => {
          clearTimeout(timeout);
          if (result?.error) reject(new Error('save failed'));
          else resolve();
        });
      });
      const saved = api.currentVisitorConsent();
      if (categories.some(category => saved[category] !== (consent[category] ? 'yes' : 'no'))) throw new Error('not saved');
      dialog.close();
    } catch {
      status.textContent = dialog.dataset.saveError;
    } finally {
      saving = false;
      setBusy(false);
    }
  };
  if (cookieSettingsEnabled) {
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-manage-cookies]');
      if (trigger) { event.preventDefault(); open(trigger); }
    });
    loadPrivacy().catch(() => {});
    dialog.querySelector('[data-cookie-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => opener?.focus());
    form.addEventListener('submit', event => { event.preventDefault(); save('custom'); });
    form.querySelectorAll('[data-cookie-choice]').forEach(button => button.addEventListener('click', () => save(button.dataset.cookieChoice)));
  }

  const policy = document.querySelector('.shopify-policy__container');
  if (!policy) return;
  const body = policy.querySelector('.shopify-policy__body');
  const title = policy.querySelector('.shopify-policy__title');
  if (!body || !title) return;
  if (location.pathname.endsWith('/terms-of-service') && document.documentElement.lang.startsWith('en')) title.querySelector('h1').textContent = dialog.dataset.terms;
  const root = dialog.dataset.rootUrl.replace(/\/$/, '');
  const nav = document.createElement('nav');
  nav.className = 'vsk-policy-nav';
  nav.setAttribute('aria-label', dialog.dataset.policyNav);
  [[dialog.dataset.privacy,'privacy-policy'],[dialog.dataset.terms,'terms-of-service']].forEach(([label,path]) => {
    const link = document.createElement('a');
    link.textContent = label;
    link.href = `${root}/policies/${path}`;
    if (location.pathname.endsWith(`/${path}`)) link.setAttribute('aria-current','page');
    nav.append(link);
  });
  if (cookieSettingsEnabled) {
    const cookie = document.createElement('button');
    cookie.type = 'button';
    cookie.textContent = dialog.dataset.cookieTitle;
    cookie.setAttribute('data-manage-cookies','');
    nav.append(cookie);
  }
  title.after(nav);
  body.querySelectorAll('p').forEach(paragraph => {
    if (/^(SECTION\s+\d+\s*[-–—]|OVERVIEW$)/i.test(paragraph.textContent.trim()) && paragraph.textContent.length < 160) {
      const heading = document.createElement('h2');
      heading.textContent = paragraph.textContent.trim();
      paragraph.replaceWith(heading);
    }
  });
  const headings = [...body.querySelectorAll('h2')];
  if (!headings.length) return;
  const layout = document.createElement('div');
  layout.className = 'vsk-policy-layout';
  const toc = document.createElement('details');
  toc.className = 'vsk-policy-toc';
  toc.open = window.matchMedia('(min-width:990px)').matches;
  const summary = document.createElement('summary');
  summary.textContent = dialog.dataset.onPage;
  const list = document.createElement('ol');
  headings.forEach((heading,index) => {
    heading.id ||= `policy-section-${index + 1}`;
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    item.append(link);
    list.append(item);
  });
  toc.append(summary,list);
  body.before(layout);
  layout.append(toc,body);
  const observer = new IntersectionObserver(entries => {
    const visible = entries.find(entry => entry.isIntersecting);
    if (!visible) return;
    list.querySelectorAll('a').forEach(link => {
      if (link.hash === `#${visible.target.id}`) link.setAttribute('aria-current','location');
      else link.removeAttribute('aria-current');
    });
  },{rootMargin:'-15% 0px -65% 0px'});
  headings.forEach(heading => observer.observe(heading));
})();
